// API configuration - v2
const API_URL = process.env.REACT_APP_API_URL || 'https://thepinbook.onrender.com';
export default API_URL;